<template>
    <div class="course-list">
        <VerticalListing
            v-if="shouldShowVerticalListing"
            class="course-list__content"
            :items="searchResults"
            :canShowCourseDetails="canShowCourseDetails"
        />
        <MosaicListing
            v-else
            class="course-list__content"
            :items="searchResults"
            :canShowCourseDetails="canShowCourseDetails"
        />
        <LoadMore class="course-list__load-more"/>
        <TotemBackToTop/>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import MosaicListing from 'components/searchable-listing/listings/MosaicListing'
    import VerticalListing from 'components/searchable-listing/listings/VerticalListing'
    import LoadMore from 'components/searchable-listing/LoadMore'

    export default {
        components: {
            LoadMore,
            VerticalListing,
            MosaicListing,
        },
        computed: {
            ...mapGetters({
                isModalOpen: 'Watchlists/isModalOpen',
                isContextMenuOpen: 'Watchlists/getCurrentMenuOpened',
                isListViewVertical: 'getListViewToggleState',
                isLoggedIn: 'isLoggedIn',
                searchResults: 'Search/searchResults'
            }),
            shouldShowVerticalListing () {
                return this.isListViewVertical && !this.isMobileView
            },
            canShowCourseDetails () {
                return !this.isModalOpen && !this.isContextMenuOpen
            }
        },
        created () {
            this.$store.dispatch('Search/doSearch')
        },
        watch: {
            async isLoggedIn (isLoggedIn) {
                if (isLoggedIn) {
                    await this.$store.dispatch('Search/clearItemsAndResetPagination')
                    await this.$store.dispatch('Search/doSearch')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.course-list {
    display: flex;
    flex-direction: column;
    margin: 20px 0 0;

    &__content {
        @include course_list;
    }

    &__load-more {
        align-self: center;
        margin: 50px;
    }
}
</style>
